import React from 'react'
import { isEmpty } from 'lodash'
import {
  Box,
  Grid,
  RadioGroup,
  FormControl,
  FormHelperText,
  FormControlLabel,
  Radio,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { Controller, useFormContext } from 'react-hook-form'

import { AutocompleteTypeAndSearch } from 'components'
import useStyles from './styles'
import useFetch from 'hooks/useFetch'
import * as service from 'service'
import constants from 'constants/index'

const REPORTABLE_STATUS = [
  constants.phishing.SENDING_STATUS_ID,
  constants.phishing.FINISHED_STATUS_ID,
]

const PhishingForm = () => {
  const { control, watch, errors, clearError } = useFormContext()
  const reportSelected = watch('reportSelected')
  const classes = useStyles()

  const { response: campaignsResponse, isLoading: loadingCampaigns } = useFetch(
    service.dponet.phishingCampaigns.get,
    {
      status: REPORTABLE_STATUS,
      perPage: 1,
    },
  )

  const hasCampaigns = !isEmpty(campaignsResponse?.data?.phishingCampaigns)
  const noCampaignsAvailable = !loadingCampaigns && !hasCampaigns

  const CampaignList = async (term) => {
    try {
      const response = await service.dponet.phishingCampaigns.get({
        name: term,
        status: REPORTABLE_STATUS,
        perPage: 9999,
      })
      return response?.data?.phishingCampaigns || []
    } catch {
      return []
    }
  }

  return (
    <Grid item xs={12}>
      {noCampaignsAvailable && (
        <Box mb={2}>
          <Alert variant="filled" severity="warning">
            Nenhuma campanha de phishing enviada ou finalizada foi encontrada.
            Crie uma campanha antes de gerar o relatório.
          </Alert>
        </Box>
      )}
      <FormControl
        component="fieldset"
        error={!!errors.reportSelected}
        disabled={noCampaignsAvailable}
      >
        <Controller
          name="reportSelected"
          control={control}
          defaultValue=""
          as={
            <RadioGroup>
              <FormControlLabel
                value={constants.phishing.REPORT_TYPES.GENERAL}
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Relatório geral"
                disabled={noCampaignsAvailable}
              />
              <FormControlLabel
                value={constants.phishing.REPORT_TYPES.BY_CAMPAIGN}
                control={<Radio classes={{ checked: classes.checked }} />}
                className={classes.radioLabel}
                label="Relatório por campanha"
                disabled={noCampaignsAvailable}
              />
            </RadioGroup>
          }
          onChange={([e]) => {
            clearError('reportSelected')
            return e.target.value
          }}
        />
        {!!errors.reportSelected && (
          <FormHelperText error={!!errors.reportSelected}>
            {errors.reportSelected.message}
          </FormHelperText>
        )}
      </FormControl>

      {reportSelected === constants.phishing.REPORT_TYPES.BY_CAMPAIGN && (
        <Box mt={1}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <AutocompleteTypeAndSearch
                name="campaignId"
                minCharsToSearch="2"
                requestToLoadOptions={CampaignList}
                textField={{
                  label: 'Nome da campanha',
                  variant: 'outlined',
                  error: !!errors.campaignId,
                  helperText: errors?.campaignId?.message,
                }}
              />
            </Grid>
          </Grid>
        </Box>
      )}
    </Grid>
  )
}

export default PhishingForm
